const cognitoConfig = {
  region: process.env.REACT_APP_COGNITO_REGION || 'us-east-1',
  userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
  clientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
  domain: process.env.REACT_APP_COGNITO_DOMAIN,
  scopes: 'openid email profile',
};

// Cognito pool registers callback URLs with wildcard, e.g. http://localhost:3000/*
export const getRedirectUri = () => `${window.location.origin}/*`;

export const getLogoutUri = () => `${window.location.origin}/*`;

export const getAuthorizeUrl = () =>
  `https://${cognitoConfig.domain}/login`;

export const getTokenUrl = () =>
  `https://${cognitoConfig.domain}/oauth2/token`;

export const getLogoutUrl = () =>
  `https://${cognitoConfig.domain}/logout`;

export const getIssuer = () =>
  `https://cognito-idp.${cognitoConfig.region}.amazonaws.com/${cognitoConfig.userPoolId}`;

export default cognitoConfig;
